import { GetServerSidePropsContext } from 'next';
import compress from 'graphql-query-compress';
import {
  formatSections,
  hydrateSections,
} from '@/utils/contentful-data-formatters';
import { formatSearchSection } from '@/utils/contentful-data-formatters/contentful-data-formatters';
import ContentfulProvider from '../../providers/contentful';
import {
  CollectOnlineContentfulResponse,
  CollectOnlinePageProperties,
} from './collect-online-page.types';
import { formatMicrocopy } from '../../utils/format-microcopy';
import { collectOnlinePageQuery } from './collect-online-page.query';
import { getSession } from '../../providers/auth0';

export const collectOnlinePageHandler = async ({
  req,
  res,
}: GetServerSidePropsContext): Promise<CollectOnlinePageProperties> => {
  const { opco, b2bToken } = req;
  const session = await getSession({ opco, requestResponse: [req, res] });

  const contentfulRequest = new ContentfulProvider(
    opco,
  ).makeContentfulRequest<CollectOnlineContentfulResponse>({
    query: compress(collectOnlinePageQuery),
  });

  const contentfulResponse = await contentfulRequest;

  const microcopy = formatMicrocopy(
    contentfulResponse.data.microcopyCollection.items,
  );

  const updatedTopSection = await hydrateSections(
    contentfulResponse?.data?.pageCollectOnlineCollection?.items[0]
      ?.topSectionCollection,
    opco,
    b2bToken,
    session,
  );

  const topSection = formatSections(updatedTopSection, microcopy) ?? null;

  const heroSection =
    contentfulResponse?.data?.pageCollectOnlineCollection?.items[0]
      ?.heroSection;

  return {
    pageTitle:
      contentfulResponse?.data?.pageCollectOnlineCollection?.items[0]
        ?.pageTitle ??
      microcopy?.collectonline_pagetitle ??
      '',
    partnersSectionAriaLabel:
      microcopy?.collectonline_section_arialabel_partnerssection ?? '',
    topSection: topSection ?? null,
    heroSection: heroSection
      ? formatSearchSection(heroSection, microcopy)
      : null,
  };
};
